module.exports = __webpack_public_path__ + "img/icon-navigation.61cbc317.png";